import { useCallback, useState } from "react";

export const useHooks = () => {
  const [openBound, setOpenBound] = useState(true);
  const [openSold, setOpenSold] = useState(true);
  const [openStickyNote, setOpenStickyNote] = useState(true);
  const [openPricing, setOpenPricing] = useState(true);

  const onCloseBound = useCallback(() => {
    setOpenBound(false);
  }, []);

  const onCloseSold = useCallback(() => {
    setOpenSold(false);
  }, []);

  const onCloseStickyNote = useCallback(() => {
    setOpenStickyNote(false);
  }, []);

  const onClosePricing = useCallback(() => {
    setOpenPricing(false);
  }, []);

  return {
    openBound,
    openSold,
    openStickyNote,
    openPricing,
    onCloseBound,
    onCloseSold,
    onCloseStickyNote,
    onClosePricing
  } as const;
};
